<script>
import InfoCards from "@js/components/Sections/InfoCards/Components/InfoCards.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import shield_svg from '@img/guarantee/shield.svg';
import star_svg from '@img/guarantee/star.svg';
import clock_svg from '@img/guarantee/clock.svg';
import money_svg from '@img/guarantee/money.svg';
import delivery_svg from '@img/guarantee/delivery.svg';
import certificate_svg from '@img/guarantee/certificate.svg';

export default {
    name: "CompanyGuarantees",
    components: {OnlyDesktop, InfoCards},
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'Гарантия качества бетонных плит',
                    description: 'Мы производим бетонные плиты, которые соответствуют всем требованиям ГОСТ и проходят строгий контроль на каждом этапе производства. Прочные и долговечные плиты обеспечивают безопасность и надежность ваших строительных проектов.',
                },
                {
                    logo: certificate_svg,
                    title: 'Сертифицированные материалы',
                    description: 'Все наши бетонные плиты изготавливаются из высококачественных и экологически чистых материалов. Это гарантирует их устойчивость к нагрузкам, влаге и перепадам температур.',
                },
                {
                    logo: clock_svg,
                    title: 'Соблюдение сроков поставки',
                    description: 'Мы ценим ваше время, поэтому доставляем бетонные плиты точно в согласованные сроки. Благодаря профессиональной логистике и собственному автопарку доставка осуществляется быстро и без задержек.',
                }
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'Прозрачные цены без скрытых доплат',
                    description: 'Вы всегда знаете точную стоимость бетонных плит заранее. Мы не добавляем скрытые комиссии, а также предлагаем выгодные условия для оптовых покупателей и постоянных клиентов.',
                },
                {
                    logo: delivery_svg,
                    title: 'Гарантия сохранности при доставке',
                    description: 'Наши бетонные плиты транспортируются в соответствии с требованиями безопасности, чтобы исключить повреждения в процессе доставки. Мы гарантируем, что продукция прибудет на ваш объект в идеальном состоянии.',
                },
                {
                    logo: star_svg,
                    title: 'Гарантийный срок на бетонные плиты',
                    description: 'Мы уверены в качестве нашей продукции и предоставляем гарантию на бетонные плиты. Это подтверждает их соответствие всем эксплуатационным нормам и требованиям.',
                }
            ],
        }
    }
}
</script>

<template>
    <InfoCards :title="'Гарантии при работе'"
               :items_group_1="items_group_1"
               :items_group_2="items_group_2"/>
</template>

<style scoped lang="scss">

</style>
